import $ from 'jquery';
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';
import {BllinkLogger} from "./bllink_loggers";
import BllinkUtils from "./utils";
import {removeTagsAndDecimalsFromFileName} from '../shared/statelessMethods';

let jsUtils = BllinkUtils.JsExtras;
const EXTENTIONS = {
    excel: 'xlsx',
    csv: 'csv'
};

export default class TableToExcel{

    /**
     * @param {string} fileName
     * @param {'excel' | 'csv'} type
     * @param {boolean} disableFileSave
     * @param {string} tableID
     * @param {string[]} ignoreColumns
     */
    static exportToExcel2(
        fileName='report',
        type = 'excel',
        disableFileSave = false,
        tableID='table',
        // ignored since we can't parse them as link right now
        // ignoreColumns should contain '' to hide columns with empty string header, like tooltip
        ignoreColumns=['' ,'אישור תשלום', 'קבלה']
    )
    {
        const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
        const fileExtension = '.' + EXTENTIONS[type]; // .xlsx or .csv

        let jsonTable = this.tableToJSON(document.getElementById(tableID), ignoreColumns);
        BllinkLogger.info(jsonTable);

        return this.getFileWithData(jsonTable, removeTagsAndDecimalsFromFileName(fileName), fileType, fileExtension, disableFileSave)

    }

    /**
     * @param {Object[]} jsonTable
     * @param {string} fileName
     * @param {string} fileType
     * @param {'xlsx' | 'csv'} fileExtension
     * @param {boolean} disableFileSave
     * @return {Blob}
     */
    static getFileWithData(jsonTable, fileName, fileType, fileExtension, disableFileSave = false){
        BllinkLogger.info(`csvData`, jsonTable);
        const ws = XLSX.utils.json_to_sheet(jsonTable);
        let rtlOptions = {Views: [{RTL: true}]};
        const wb = { Sheets: { 'data': ws }, SheetNames: ['data'], Workbook: rtlOptions};
        const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
        const data = new Blob([excelBuffer], {type: fileType});
        if (!disableFileSave) {
            FileSaver.saveAs(data, fileName + fileExtension);
        }
        return data;
    }

    static tableToJSON(table, ignoreColumns) {
        let row, rows = table.rows;
        let rowObjects = [], title;
        for (let i=0, iLen=rows.length; i<iLen; i++) {
            row = rows[i];
            if (i===0){
                // header row
                title = this.buildTitleRow(row, ignoreColumns);
            }else{
                let rowObj = this.buildingRowData(title, row);
                rowObjects.push(rowObj);
            }
        }
        return rowObjects;
    }

    static buildTitleRow(row, ignoreColumns){
        let headers = [], ignoreIndexes = [], index = 0;
        for (const cell of row.cells){
            let headerName= this.getCellValue(cell);
            if (!ignoreColumns.includes(headerName)){
                headers.push(headerName)
            }else{
                ignoreIndexes.push(index)
            }
            index+= 1;

        }

        return {headers: headers, ignoreIndexes: ignoreIndexes}
    }

    static buildingRowData(title, row){
        let rowObj = {}, index = 0
        for (const cell of row.cells){
            const headerTitle = title.headers[index];
            if (!title.ignoreIndexes.includes(index)){
                rowObj[headerTitle] = this.getCellValue(cell)
                index += 1
            }
        }

        return rowObj;
    }

    static getCellValue(cellElement){
        // let domainUrl = document.location.origin;
        let value = $(cellElement).html();
        BllinkLogger.info(`value is `, value);

        try{
            if (BllinkUtils.Strings.isHtmlCode(value)){
                let htmlJqueryObject = $(value);
                let uri = htmlJqueryObject.attr('href');
                let excelText = htmlJqueryObject.attr('exceltext');
                if (uri) {
                    value = htmlJqueryObject.html();
                } else if (excelText) {
                    value = excelText;
                }else{
                    value = ''
                }
            }
        }catch (e) {
            BllinkLogger.info(`e is `, e);
            // if got here, then it's a plain string value
        }

        if (jsUtils.isNumeric(value)) {
            // parse as in if needed
            let floatValue = parseFloat(value);
            if (floatValue) {
                // return
                return floatValue
                // return {v: floatValue, s: { font: { name: 'Comic Sans MS', family: 4, size: 16, underline: 'double', bold: true }}}
            }
        }
        return value

    }
}
